import { useState, useMemo } from 'react';

const POSSIBLE_PERMUTATIONS = [
  [1, 2],
  [2, 3],
  [3, 1],
] as const;

export const useComparePermutationsOfTwo = () => {
  const [currentPermutation, setCurrentPermutation] = useState(0);

  const { goToNextPermutation, goToPrevPermutation, goToSpecificPermutation } =
    useMemo(
      () => ({
        goToNextPermutation: () =>
          setCurrentPermutation((prev) => (prev === 2 ? 0 : prev + 1)),
        goToPrevPermutation: () =>
          setCurrentPermutation((prev) => (prev === 0 ? 2 : prev - 1)),
        goToSpecificPermutation: (permutationIndex: 0 | 1 | 2) =>
          setCurrentPermutation(permutationIndex),
      }),
      []
    );

  return {
    goToNextPermutation,
    goToPrevPermutation,
    goToSpecificPermutation,
    currentPermutations: POSSIBLE_PERMUTATIONS[currentPermutation],

    prevPermutation:
      POSSIBLE_PERMUTATIONS[
        currentPermutation > 0 ? currentPermutation - 1 : 2
      ],
    nextPermutation:
      POSSIBLE_PERMUTATIONS[
        currentPermutation < 2 ? currentPermutation + 1 : 0
      ],
    currentPermutationIndex: currentPermutation,
  };
};
